module.exports = __webpack_public_path__ + "img/Celular.729bd2c7.svg";